import { DriverNode } from '@/apollo/graphql'
import { customerDisplayLabel } from '@/utils'

export const buildData = (selectedItem?: Partial<DriverNode>) => {
  return [
    {
      name: 'name',
      type: 'text',
      label: 'name',
      required: true,
      className: 'w-50',
      value: selectedItem?.name,
    },
    {
      name: 'email',
      type: 'text',
      required: true,
      label: 'email',
      className: 'w-50',
      value: selectedItem?.email,
    },
    {
      name: 'phone',
      type: 'text',
      required: true,
      label: 'phone',
      className: 'w-50',
      value: selectedItem?.phone,
    },
    {
      type: 'text',
      required: true,
      name: 'address',
      label: 'address',
      className: 'w-50',
      value: selectedItem?.address,
    },
    {
      type: 'text',
      required: true,
      className: 'w-50',
      name: 'additional_address',
      label: 'additional_address',
      value: selectedItem?.additionalAddress,
    },
    {
      name: 'city',
      type: 'text',
      label: 'city',
      required: true,
      className: 'w-50',
      value: selectedItem?.city,
    },
    {
      type: 'text',
      name: 'country',
      required: true,
      label: 'country',
      className: 'w-50',
      value: selectedItem?.country,
    },
    {
      label: 'birthday',
      value: selectedItem?.birthday,
    },
    {
      type: 'text',
      required: true,
      name: 'id_number',
      className: 'w-50',
      label: 'id_number',
      value: selectedItem?.id,
    },
    {
      label: 'customer',
      style: { color: '#4094f7' },
      value: customerDisplayLabel(selectedItem?.customer),
      link: `/${selectedItem?.customer?.id}/main`,
    },
  ]
}
